import { createHttpRepository } from './http/httpRepository'
import { createMemoryRepository } from './local/memoryRepository'
import type { Repository } from './repository'

export type {
  ComponentPage,
  ComponentKind,
  ComponentType,
  FleetRow,
  Health,
  InstallResult,
  InstallTarget,
  Me,
  MyShifts,
  StockRow,
  Repository,
  ScanResult,
  Revision,
  StructureLine,
  StructureSaved,
  BoardOrder,
  BuildableRevision,
  ShortageRow,
  TeamMember,
  Marking,
  Tracking,
  TreeNode,
} from './repository'

/**
 * One repository for the app, chosen once.
 *
 * **HTTP by default, including in development.** Vite proxies `/api` to the
 * local Fastify process, which is the same shape production has, so the path
 * exercised on a laptop is the path that ships. Cadence falls back to memory
 * when no API is configured; Kronos does not, because almost everything here is
 * a question only the database can answer — what is installed at
 * `arm_left.joint_3`, what this serial is — and a fallback that answers them
 * from nothing produces a screen that looks right and is fiction.
 *
 * `VITE_MEMORY_REPO=true` opts in explicitly, for working on a screen with no
 * API running. Production builds never set it.
 */
export const repository: Repository =
  import.meta.env.DEV && import.meta.env.VITE_MEMORY_REPO === 'true'
    ? createMemoryRepository()
    : createHttpRepository()
